const KEY = "tgpe:promo_footer_dismissed_at";
/** Re-show the footer card 7 days after dismissal. */
export const PROMO_REDISPLAY_AFTER_MS = 7 * 24 * 60 * 60 * 1000;

export interface PromoDismissalStorage {
  isDismissed(now: Date): boolean;
  dismiss(now: Date): void;
  reset(): void;
}

/**
 * localStorage-backed promo dismissal: stores the ISO timestamp of the
 * last dismissal and treats the card as visible again 7 days later.
 *
 * `now` is a parameter (not `Date.now()` inside) so consumers can drive
 * deterministic tests.
 */
export const promoDismissal: PromoDismissalStorage = {
  isDismissed(now) {
    const raw = localStorage.getItem(KEY);
    if (!raw) return false;
    const ts = Date.parse(raw);
    if (Number.isNaN(ts)) return false;
    return now.getTime() - ts < PROMO_REDISPLAY_AFTER_MS;
  },
  dismiss(now) {
    localStorage.setItem(KEY, now.toISOString());
  },
  reset() {
    localStorage.removeItem(KEY);
  },
};
